// extracted by mini-css-extract-plugin
export var bodySections = "_e8-8";
export var gray = "_e8-7";
export var green = "_e8-4";
export var iconContainer = "_e8-9";
export var iconWidgetContainer = "_e8-1";
export var phoneIcon = "_e8-2";
export var red = "_e8-5";
export var statusDot = "_e8-3";
export var widgetContainer = "_e8-0";
export var yellow = "_e8-6";